export const FBM_AGENT_CONSENTED_AT = ['facebookMessengerAgentConsentAt'];
export const FBM_AGENT_DISMISSED_CONSENT_AT = ['facebookMessengerAgentConsentDismissedAt'];